const handlePortugueseHeader = () => {
    if (!window.obData || !window.obData.portugueseHeaderStream) {
        return;
    }

    const streampage = document.querySelector('.listing-page');
    const itempage = document.querySelector('.single-page');
    if (streampage || itempage) {
        const streamPageID = document.getElementById('page-type-identifier').dataset.collectionId;
        if (streamPageID) {
            const config = window.obData.portugueseHeaderStream;
            if (config.includes(streamPageID)) {
                document.body.classList.add('ptheader');
                const enHeader = document.querySelector('.injected-header.en');
                const ptHeader = document.querySelector('.injected-header.pt');
                const enFooter = document.querySelector('.injected-footer.en');
                const ptFooter = document.querySelector('.injected-footer.pt');
                if (enHeader && ptHeader) {
                    enHeader.style.display = 'none';
                    ptHeader.style.display = 'block';
                }
                if (enFooter && ptFooter) {
                    enFooter.style.display = 'none';
                    ptFooter.style.display = 'block';
                }
            }
        }
    }
};

function mobileViewPTheader() {
    if (document.body.classList.contains('ptheader')) {
        const hamburgermenu = document.querySelector('.injected-header.pt .menu-toggle');
        if (hamburgermenu) {
            hamburgermenu.addEventListener('click', function() {
                document.querySelector('.injected-header.pt').classList.toggle('open');
                hamburgermenu.classList.toggle('open');
                document.querySelector('.injected-header.pt .menu-wrapper').classList.toggle('open');
            });
        }
        const level1menu = document.querySelectorAll('.injected-header.pt > .menu-item-has-children');
        if (level1menu) {
            level1menu.forEach((element) => {
                element.addEventListener('click', function(e) {
                    if (!this.parentElement.classList.contains('open')) {
                        element.parentElement.classList.add('open');
                        element.nextElementSibling.classList.add('open');
                    } else {
                        element.parentElement.classList.remove('open');
                        element.nextElementSibling.classList.remove('open');
                    }
                });
            });
        }
    }
}
/* Uberflip GWL OB-9016 start here */
function handlescrollptheader() {
    if (document.body.classList.contains('ptheader')) {
        const header = document.querySelector('.injected-header.pt');
        if (header) {
            const scrollheader = window.scrollY;
            if (scrollheader > 1) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }
    }

}
/* Uberflip GWL OB-9016 end here */

module.exports = { handlePortugueseHeader, mobileViewPTheader, handlescrollptheader };


// WEBPACK FOOTER //
// ./scriptPartials/handlePt.js